export default __webpack_public_path__ + "ed3e9c46f0fd5afaeb1b9004f5bf2319.png";